/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/api/request'; // 获取是否订阅

export function getNotifyVisitUserGrab(data) {
  return request.get('/v2/notify/visitUserGrab', {
    params: data
  });
} // 设置订阅

export function setNotifyVisitUserGrab() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request.put('/v2/notify/visitUserGrab', data);
} // 抢单

export function setOrdervisitUserGrab(data) {
  return request.put('/v2/order/visitUserGrab', data);
} // 捞回工单

export function setOrderRevokeGrab(data) {
  return request.put('/v2/order/revokeGrab', data);
}
export function setOrderPutIntoGrab(data) {
  return request.put('/v2/order/grab', data);
} // 进度 指派默认 设置

export function getProcessDispatchSet(data) {
  return request.get('/v2/processSet/queryDispatchOrder', {
    params: data
  });
}